import { Component, Injectable, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { getShowPermissionName } from 'app/app.config';
import { TempAccessSessionService } from 'app/services/temp-access-session.service';
import { first } from 'rxjs/operators';
import { hasUserIdentity } from '@prisma/no-role/user-identity';

// Va ANTES del componente: con emitDecoratorMetadata, design:paramtypes del ctor se evalúa al
// decorar la clase, o sea durante la evaluación del módulo. Declarado más abajo, esa referencia
// cae en la TDZ y explota con "Cannot access 'DataAnauthorizedService' before initialization".
@Injectable({
  providedIn: 'root',
})
export class DataAnauthorizedService {
  private customData: any;

  setCustomData(data: any) {
    this.customData = data;
  }

  getCustomData(): string {
    return Array.isArray(this.customData) ? this.customData.join(', ') : '';
  }
}

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
})
export class UnauthorizedComponent implements OnInit {
  permissionName = '';
  showFlag = getShowPermissionName();
  constructor(
    private dataAnauthorizedService: DataAnauthorizedService,
    private oidcSecurityService: OidcSecurityService,
    private tempAccessSession: TempAccessSessionService,
    private router: Router
  ) {}
  ngOnInit(): void {
    this.permissionName = this.dataAnauthorizedService.getCustomData();
    this.redirectIfUserHasNoRole();
  }

  /*
  PLATFORM-SEC03 (F03): un usuario SIN ROL no tiene ningun permiso, asi que NgxPermissionsGuard lo
  manda a /unauthorized antes de que corra PrismaCanActivateRoute. Ese mensaje ("sin permisos de
  acceso a ESTA pantalla") no aplica a su caso: no le falta un permiso puntual, no tiene rol alguno.
  Se lo deriva a la pantalla informativa para que el aterrizaje sea unico desde cualquier URL.

  Los invitados por acceso temporal (codigo) tienen su propio ruteo restringido hacia /unauthorized
  y NO son usuarios sin rol: se los excluye explicitamente (F04b, requisito duro del spec).
  */
  private redirectIfUserHasNoRole(): void {
    if (this.tempAccessSession.isValid()) return;

    this.oidcSecurityService
      .getUserData()
      .pipe(first())
      .subscribe((data: any) => {
        // Se exige identidad real (ver hasUserIdentity): getUserData() emite "" antes de tener los datos
        // del token, y actuar sobre esa emision mandaria a /no-role a quien no inicio sesion.
        const isLogged = hasUserIdentity(data);
        const hasRole = Boolean(data?.role?.length);

        if (isLogged && !hasRole) this.router.navigate(['/no-role']);
      });
  }
}
